import { msg } from '@gonfalon/messages/msg';
import { Button, ListBox, ListBoxItem, Popover, Select, SelectValue } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';
import clsx from 'clsx';

import { type MonthOption } from '../../../../types';

import styles from './PickerBase.module.css';

type MonthPickerProps = {
  value?: MonthOption['key'];
  onChange: (key: MonthOption['key']) => void;
  monthOptions: MonthOption[];
};

export function MonthPicker({ value, onChange, monthOptions }: MonthPickerProps) {
  return (
    <Select
      value={value}
      onChange={(key) => onChange(key as string)}
      aria-label="month-picker"
      placeholder={msg('billing.usageControls.monthPlaceholder')}
      className={clsx(styles.container, { [styles.selected]: !!value })}
    >
      <>
        <Button className={styles.usageButton}>
          <SelectValue className={styles.selectedValue} />
          <Icon name="chevron-down" size="small" slot="end-icon" />
        </Button>
        <Popover>
          <ListBox className={styles.options}>
            {monthOptions.map(({ label, key }) => (
              <ListBoxItem id={key} key={key} className={styles.optionItem}>
                {label}
              </ListBoxItem>
            ))}
          </ListBox>
        </Popover>
      </>
    </Select>
  );
}
